module.exports = __webpack_public_path__ + "static/media/bank.54a61b14.png";